import { render, staticRenderFns } from "./hotCourseCard.vue?vue&type=template&id=1ddae9af&scoped=true&"
import script from "./hotCourseCard.vue?vue&type=script&lang=js&"
export * from "./hotCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./hotCourseCard.vue?vue&type=style&index=0&id=1ddae9af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddae9af",
  null
  
)

export default component.exports